import React from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon, HeadphonesIcon, MonitorIcon } from 'lucide-react';
export function HeroSection() {
  return <header className="section-dramatic min-h-[90vh] flex flex-col items-center justify-center px-4 py-20 border-b border-navy-800" data-id="element-72">
      {/* Dramatic Background */}
      <div className="flag-bg opacity-40 mix-blend-overlay" data-id="element-73"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-navy-950/60 via-navy-950/80 to-navy-950 z-0 pointer-events-none" data-id="element-74"></div>
      <div className="absolute inset-0 bg-flag-overlay z-0 pointer-events-none" data-id="element-75"></div>

      {/* Crowd Silhouette at bottom */}
      <div className="crowd-bottom opacity-80" data-id="element-76"></div>

      {/* Subtle flag stripes at the very top */}
      <div className="absolute top-0 left-0 right-0 h-1.5 flex z-20" aria-hidden="true" data-id="element-77">
        <div className="flex-1 bg-patriot-red" data-id="element-78"></div>
        <div className="flex-1 bg-white" data-id="element-79"></div>
        <div className="flex-1 bg-patriot-blue" data-id="element-80"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto flex flex-col items-center text-center space-y-8" data-id="element-81">
        {/* Banner image */}
        <img src="https://cdn.magicpatterns.com/uploads/aXp9JMtrTKRkSYnyKSVdNe/barra.png" alt="Limited Time Offer Banner" className="w-full max-w-2xl h-auto" data-id="element-82" />

        <div className="animate-float inline-flex items-center gap-3 px-4 py-1.5 text-xs md:text-sm font-sans font-bold tracking-widest text-white border border-patriot-red/50 bg-patriot-red/20 uppercase rounded-full backdrop-blur-md shadow-[0_0_20px_rgba(178,34,52,0.3)]" data-id="element-83">
          SPECIAL BUNDLE OFFER - LIMITED TIME
        </div>

        {/* eBook Cover — above the headline */}
        <div className="relative group" data-id="element-84">
          <div className="absolute -inset-6 bg-patriot-red/20 blur-3xl rounded-full pointer-events-none transition-opacity duration-500 group-hover:opacity-100 opacity-60" data-id="element-85"></div>
          <div className="absolute -inset-10 bg-patriot-blue/20 blur-3xl rounded-full pointer-events-none transition-opacity duration-500 group-hover:opacity-100 opacity-60" data-id="element-86"></div>
          <img src="https://cdn.magicpatterns.com/uploads/r4gbiAFk5aSaL3Q2qWB2VG/audiobook.png" alt="The Voice They Couldn't Silence — Audiobook Cover" className="relative w-56 md:w-72 lg:w-80 h-auto drop-shadow-[0_30px_60px_rgba(0,0,0,0.8)] hover:scale-105 transition-all duration-500" data-id="element-87" />
        </div>

        {/* Format line: Audiobook + Instant Download eBook */}
        <div className="flex items-center justify-center gap-3 text-slate-300 text-sm md:text-base font-bold uppercase tracking-[0.15em]" data-id="element-88">
          <HeadphonesIcon className="w-5 h-5 text-white" data-id="element-89" />
          <span className="text-white text-[9px]" data-id="element-90">Audiobook</span>
          <span className="text-patriot-red text-lg font-black" data-id="element-91">+</span>
          <span className="text-white text-[9px]" data-id="element-92">Instant Download eBook</span>
          <MonitorIcon className="w-5 h-5 text-white" data-id="element-93" />
        </div>

        {/* Headline */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tight text-shadow-md leading-none" data-id="element-94">
          The day{' '}
          <span className="text-transparent bg-clip-text bg-red-gradient text-shadow-red" data-id="element-95">
            silence
          </span>{' '}
          tried to win
        </h1>

        <p className="max-w-3xl text-2xl md:text-3xl font-serif italic text-white leading-relaxed text-shadow-sm" data-id="element-96">
          The chronicle of the sacrifice that changed the future of the West.
        </p>

        <div className="w-24 h-1 bg-red-gradient mx-auto my-2" data-id="element-97"></div>

        <p className="max-w-3xl text-xl text-slate-300 leading-relaxed font-medium" data-id="element-98">
          When arguments can no longer defeat the truth, they resort to
          violence. <br className="hidden md:block" data-id="element-99" />
          <span className="text-white font-bold bg-navy-900/80 px-3 py-1 mt-4 inline-block border-l-4 border-patriot-red shadow-lg" data-id="element-100">
            Read the exclusive warning before they silence the truth forever.
          </span>
        </p>

        <div className="pt-4 flex flex-col items-center gap-4" data-id="element-101">
          <CTAButton className="w-full sm:w-auto text-base md:text-lg" data-id="element-102">
            CLAIM YOUR COPY NOW — BEFORE IT'S GONE
          </CTAButton>
          <p className="text-sm font-mono text-slate-400 uppercase tracking-widest flex items-center gap-2" data-id="element-103">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-104"></span>
            Join 10,000+ readers who already claimed their copy
          </p>
        </div>
      </div>
    </header>;
}